/// <reference types="@types/google.maps" />

export interface PlaceAutocompleteOnSelectArgs {
  city?: string;
  countryCode?: string;
  postalCode?: string;
  street?: string;
  streetNumber?: string;
  latitude?: number;
  longitude?: number;
}

export enum PLACE_AUTOCOMPLETE_ACTION_TYPES {
  LOAD_PREDICTION_END = 'LOAD_PREDICTION_END',
  LOAD_PREDICTION_FAIL = 'LOAD_PREDICTION_FAIL',
  LOAD_PLACE_ID_START = 'LOAD_PLACE_ID_START',
  LOAD_PLACE_ID_END = 'LOAD_PLACE_ID_END',
  CHANGE_TEXT_INPUT = 'CHANGE_TEXT_INPUT',
  OPEN_DROPDOWN = 'OPEN_DROPDOWN',
  CLOSE_DROPDOWN = 'CLOSE_DROPDOWN',
  ARROW_NAVIGATION = 'ARROW_NAVIGATION',
  CLEAR_INPUT = 'CLEAR_INPUT',
  ON_SELECT = 'ON_SELECT',
}

export enum PLACE_TYPE {
  GOUV = 'GOUV',
  GOOGLE = 'GOOGLE',
}

export interface Place {
  id: string;
  mainText: string;
  secondaryText?: string;
  description: string;
  originType: PLACE_TYPE;
  data?: PlaceAutocompleteOnSelectArgs;
}
